<template>
  <div style="margin-top: 5px">
    <van-form ref="formRules">
      <van-cell-group inset >
        <van-field v-model="model.no" type="text" :rules="formRules.no"
                   label="订单号" placeholder="请输入订单号(选填)" disabled center readonly />
        <van-field v-model="model.clerkName"  @click="show = true" name="picker" :rules="formRules.clerkName"
                   label="店员" placeholder="点击选择店员" is-link readonly required />
        <van-field v-model="model.itemContent" type="text"  maxlength="100" :rules="formRules.itemContent"
                   label="服务内容" placeholder="请输入服务内容" required center/>
        <van-field v-model="model.totalAmount" type="number" :rules="formRules.totalAmount"
                   label="订单金额" placeholder="请输入订单金额" required center />
        <div style="display: flex">
          <van-field v-model="model.clerkWagesRatio" type="number" :rules="formRules.clerkWagesRatio" style="width: 90%;padding:10px 5px 10px 16px"
                     label="店员提成比例" placeholder="请输入店员提成比例" required center />
          <div style="line-height: 54px;font-size: 18px;color: #646566">%</div>
        </div>
        <van-field :value="model.clerkWagesAmount" type="number" :rules="formRules.clerkWagesAmount"
                   label="店员提成金额" placeholder="输入订单金额和提成比例自动换算" disabled required center readonly/>
        <van-field v-model="model.startTime" @click="showDatetimePickerPopup('start')" name="picker" :rules="formRules.startTime"
                   label="下单时间" placeholder="点击选择下单时间" is-link readonly required/>
        <van-field v-model="model.endTime" @click="showDatetimePickerPopup('end')" :rules="formRules.endTime"
                   label="完成时间" placeholder="点击选择完成时间" is-link readonly name="picker"/>
        <van-field v-model="model.continueRemark" rows="2" maxlength="100"  type="textarea"
                   label="续单备注" placeholder="请输入备注（选填）" autosize/>
        <van-field v-model="model.remark" rows="2" maxlength="100"  type="textarea"
                   label="订单备注" placeholder="请输入备注（选填）" autosize/>
        <van-field name="uploader" label="上传截图">
          <template #input>
            <van-uploader v-model="model.photoUrls" multiple :max-count="3"
                          accept="image/*" upload-text="点击上传" preview-size="60" :before-read="beforeRead"
                          :after-read="afterRead"/>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
    <div style="margin: 16px;">
      <van-button round block color="#1989fa" native-type="submit"   @click="updateClick()">
        修改
      </van-button>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-search v-model="keyword" placeholder="请输入店员ID或店员名称搜索"/>
      <div style="height: 500px">
        <van-list
            v-model="loading"
            :finished="listFinished"
            finished-text="没有更多了"
            @load="onLoad">
          <div class="clerkBox" v-for="(item,index) in clerkList" :key="index" @click="clerkClick(item.id,item.name)">
            {{ item.name }}
          </div>
        </van-list>
      </div>

    </van-popup>
    <!-- 选择日期 -->
    <van-popup
        v-model="datetimePickerPopupShow"
        class="datetime-picker-popup"
        position="bottom">
      <van-datetime-picker
          v-model="datetimePicker.value"
          type="datetime"
          :min-date="datetimePicker.minDate"
          :formatter="datetimePickerFormatter"
          @confirm="datetimePickerConfirm"
          @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>


  </div>
</template>

<script>
import Vue from 'vue';
import {
  Cell,
  CellGroup,
  Popup,
  Search,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Field,
  Button,
  Dialog,
  Toast,
  DatetimePicker,
  Uploader,
  Form,
  Icon,
  List,
  NoticeBar
} from 'vant';
import {getClerkList, updateOutOrder} from '@/api/kf/out-order'
import Decimal from "decimal.js";
import moment from "moment";
import {getOutOrder,} from "@/api/kf/out-order"
import lrz from "lrz";

Vue.use(Cell)
    .use(CellGroup)
    .use(Popup)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(RadioGroup)
    .use(Radio)
    .use(Field)
    .use(Button)
    .use(Toast)
    .use(DatetimePicker)
    .use(Uploader)
    .use(Form)
    .use(Icon)
    .use(List)
    .use(NoticeBar)

export default {
  name: 'out-order-update',
  data() {
    return {
      datetimePickerPopupShow: false,
      datetimePicker: {
        field: null,
        value: null,
        minDate: new Date(2018, 0, 1),
      },
      model: {
        no: null,
        clerkId: null,
        clerkName: null,
        totalAmount: null,
        clerkWagesRatio: null,
        clerkWagesAmount: null,
        itemContent: null,
        startTime: null,
        endTime: null,
        continueRemark: null,
        remark: null,
        photoUrls: []
      },
      list: [],
      show: false,
      keyword: null,
      errorMessage: '1',
      formRules: {
        no: [{validator: this.orderNoValidator, message: '请输入正确的订单号（英文或数字）'}],
        clerkName: [{ required: true,trigger: 'onBlur'}],
        itemContent: [
          {required: true, trigger: 'onBlur'},
          {required: true, validator: value => {return value.trim().length != 0}, trigger: 'onBlur', message: '服务内容不能为空'},
          {required: true, validator: value => {return !(value.length > 100)}, trigger: 'onBlur', message: '不能大于100字'},
        ],
        totalAmount: [
          {required: true, validator: value => {return !(value == null || value == '')}, trigger: 'onBlur',},
          {required: true, validator: value => {return !(value < 0.01)}, trigger: 'onBlur', message: '不能小于0.01'},
          {required: true, validator: value => {return /^\d+(\.\d{1,2})?$/.test(value)}, trigger: 'onBlur', message: '格式错误（精确到小数点二位）'}
        ],
        clerkWagesRatio: [
          {required: true, validator: value => {return !(value == null || (typeof value == 'string' && value == ''))}, trigger: 'onBlur',},
          {required: true, validator: value => {return !(value < 0)}, trigger: 'onBlur', message: '不能小于0%'},
          {required: true, validator: value => {return !(value > 100)}, trigger: 'onBlur', message: '不能大于100%'},
          {required: true, validator: value => {return /^\d+?$/.test(value)}, trigger: 'onBlur', message: '请设置整数'}
        ],
        clerkWagesAmount  : [
          { required: true,validator: value => {return !(value == null || value == '')}, trigger: 'onBlur',},
          { required: true,validator: value => {return !(value < 0.01)}, trigger: 'onBlur',message: '不能小于0.01'},
          { required: true,validator: value => {return /^\d+(\.\d{1,2})?$/.test(value)}, trigger: 'onBlur',message: '格式错误（精确到小数点二位）'}
        ],
        startTime: [
          { required: true,trigger: 'onBlur'},
        ],
        endTime: [
          {validator: this.endTimeValidator,message: '完成时间必须大于下单时间'},
        ],
      },
      clerkList: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10,
    }
  },
  methods: {
    //加载数据
    onLoad(resetPage) {
      this.activeNames = []
      this.loading = true
      if (resetPage) {
        this.pageNo = 1;
        this.clerkList = []
      }
      getClerkList(
          this.keyword,
          this.pageNo,
          this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
          for (let i in data.clerkList) {
            let clerk = data.clerkList[i];
            this.clerkList.push(clerk)
          }
        } else {
          this.listFinished = true;
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '失败',
            message: data.msg
          })
        }
        this.pageNo++;
      })
    },
    // 读取前
    beforeRead() {
      return true;
    },
    // 读取后
    afterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    //日期
    showDatetimePickerPopup(field) {
      this.datetimePicker.field = field
      if (field == 'start') {
        this.datetimePicker.value = moment(this.startTime).toDate()
      } else if (field == 'end') {
        this.datetimePicker.value = moment(this.endTime).toDate()
      }
      this.datetimePickerPopupShow = true;
    },
    datetimePickerFormatter(field, value) {
      if (field === 'year') {
        return `${value}年`;
      } else if (field === 'month') {
        return `${value}月`
      } else if (field == 'day') {
        return `${value}日`
      } else if (field == 'hour') {
        return `${value}时`
      } else if (field == 'minute') {
        return `${value}分`
      }
      return value;
    },
    datetimePickerConfirm(value) {
      this.datetimePickerPopupShow = false;
      if (this.datetimePicker.field == 'start') {
        this.model.startTime = moment(value).format('YYYY-MM-DD HH:mm:ss');
      } else if (this.datetimePicker.field == 'end') {
        this.model.endTime = moment(value).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    //选择店员
    clerkClick(id, name) {
      this.model.clerkName = name
      this.model.clerkId = id
      this.show = false
    },
    //保存
    updateClick() {
      // 全局表单验证
      this.$refs.formRules.validate().then(() => {
        if (!this.model.clerkId) {
          Toast('请选择' + this.$store.state.label.clerkLabel)
          return
        }
        if (!this.model.startTime) {
          Toast('请选择下单时间')
          return
        }
        if (this.model.photoUrls.length > 3) {
          return Toast.fail('最多上传三张图片')
        }
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        updateOutOrder(
            this.model.id,
            this.model.clerkId,
            this.model.itemContent,
            Decimal.mul(this.model.totalAmount, 100),
            this.model.clerkWagesRatio,
            Decimal.mul(this.model.clerkWagesAmount, 100),
            this.model.startTime,
            this.model.endTime,
            this.model.continueRemark,
            this.model.remark,
            JSON.stringify(this.model.photoUrls)
        ).then(res => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            Dialog.alert({
              title: '提示',
              message: '修改成功'
            }).then(() => {
              this.$router.back(-1)
            })
          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$toast.fail('修改失败')
      })
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getOutOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model.id = data.outOrder.id;
          this.model.no = data.outOrder.no;
          this.model.clerkId = data.outOrder.clerkId;
          this.model.clerkName = data.outOrder.clerkName;
          this.model.totalAmount = Decimal.div(data.outOrder.totalAmount, 100);
          this.model.clerkWagesRatio = data.outOrder.clerkWagesRatio;
          this.model.clerkWagesAmount = Decimal.div(data.outOrder.clerkWagesAmount, 100);
          this.model.itemContent = data.outOrder.itemContent;
          this.model.startTime = this.formatDate(data.outOrder.startTime, 'YYYY-MM-DD HH:mm:ss');
          this.model.endTime = this.formatDate(data.outOrder.endTime, 'YYYY-MM-DD HH:mm:ss');
          this.model.continueRemark = data.outOrder.continueRemark;
          this.model.remark = data.outOrder.remark;
          let photoUrls = []
          for (const url of data.outOrder.photoUrls) {
            photoUrls.push({
              url: url
            })
          }
          this.model.photoUrls = photoUrls;
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    /** 格式化日期 */
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    decimal(num) {
      let result = (num.toString()).indexOf(".");
      if (result != -1) {
        return true
      } else {
        return false
      }
    },
    orderNoValidator() {
      if (this.model.no != null && this.model.no != '') {
        return /^[A-Za-z0-9]+$/.test(this.model.no)
      }
      return false
    },
    endTimeValidator() {
      if (this.model.endTime != null && this.model.endTime != ''
          && this.model.startTime != null && this.model.startTime != '') {
        return this.model.endTime > this.model.startTime
      }
      return true
    },
    // 验证店员提成比例
    validateClerkWagesRatio(rule, value, callback) {
      if (value == null || (typeof value == 'string' && value == '')) {
        return callback(new Error('请输入提成比例'))
      } else if (value < 0) {
        return callback(new Error('不能小于0%'))
      } else if (value > 100) {
        return callback(new Error('不能大于100%'))
      } else if (!/^\d+?$/.test(value)) {
        return callback(new Error('请设置整数'))
      }
      return callback()
    },
  },
  watch: {
    keyword: function () {
      this.onLoad(true)
    },
    'model.totalAmount'() {
      if (this.model.totalAmount != null && this.model.clerkWagesRatio != null) {
        if (this.model.clerkWagesRatio == 0) {
          this.model.clerkWagesAmount = this.model.totalAmount
        } else {
          this.model.clerkWagesAmount = Decimal.mul(this.model.totalAmount, this.formatPrice(this.model.clerkWagesRatio)).toNumber().toFixed(3).slice(0, -1)
        }
      }
    },
    'model.clerkWagesRatio'() {
      if (this.model.totalAmount != null && this.model.clerkWagesRatio != null) {
        if (this.model.clerkWagesRatio == 0) {
          this.model.clerkWagesAmount = this.model.totalAmount
        } else {
          this.model.clerkWagesAmount = Decimal.mul(this.model.totalAmount, this.formatPrice(this.model.clerkWagesRatio)).toNumber().toFixed(3).slice(0, -1)
        }
      }
    },
  },
  mounted() {
    this.loadData();
    this.onLoad(true);
  }
}
</script>

<style lang="less" scoped>
.clerkBox {
  border-bottom: 1px #f5f5f5 solid;
  padding: 15px;
}

/deep/ .van-field__control {
  padding: 5px;
  border-radius: 5px;
}

</style>
